module.exports = __webpack_public_path__ + "154d00c820cfd9fb90bc0314f15c8ed9.svg";